import { CommunicationChannelEntityValues } from './types';

export const CHANNEL_INITIAL_VALUES: CommunicationChannelEntityValues = {
  description: null,
  name: null,
  isReports: false,
  isMessages: false,
};
